import {FC} from 'react'

const Error404: FC = () => {
  return (
    <div className='search-placeholder py-20'>
      <img src='/media/assemp/icon-error.svg' alt='Erro' />
      <p className='search-placeholder-text'>Página não encontrada</p>
    </div>
  )
}

export {Error404}
